import React from "react";
import {Button, Nav, Navbar} from "react-bootstrap"
import { LoginButton } from "./buttons/login-button";
import { LogoutButton } from "./buttons/logout-button";

import { useAuth0 } from "@auth0/auth0-react";
import {RefreshButton} from "./buttons/refresh-button";
import {AppContext} from "../app-context";

function Navigation () {
    const { currentOrder, setCurrentOrder } = React.useContext(AppContext);
    const onInitialChange = (val) => user.defaultInitials = val.target.value;
    const { user, isAuthenticated } = useAuth0();

    if(isAuthenticated && !user.defaultInitials) {
        if(user.defaultInitials && user.initials.length > 0) {
            user.defaultInitials = user.initials[0]
        }
    }

    return (
        <Navbar bg="light" expand="lg">
            <Navbar.Brand className="mx-2">Commandes et expéditions</Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="ml-auto">
                    &nbsp;&nbsp;&nbsp;
                    {currentOrder._id !==0 && <><Button onClick={async () => { await setCurrentOrder({_id: 0});}} className="btn-primary">Retour à la liste</Button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                    <><RefreshButton />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>
                    {isAuthenticated ? <><LogoutButton />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</> : <><LoginButton />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                </Nav>
                {isAuthenticated ? <><form className="form-inline">
                        {user.name} / {user.role} :&nbsp;
                        <select id="initials" className="custom-select" onInput={onInitialChange}>
                            {user.initials.map((initialsItem) => (
                                <option key={initialsItem} className="col-4">{initialsItem}</option>
                            ))}
                        </select>
                    </form></> : <></>}
            </Navbar.Collapse>
        </Navbar>
    )
}

export default Navigation